import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './mediaTitle.css'

export class MediaTitle extends Component {

    static propTypes = {
        title: PropTypes.object.isRequired,
    }

    render() {

        const { recordTitle, referenceCode, appName } = this.props.title

        return (
            <div className="media-title">
                {recordTitle && <span className="record-title" title={recordTitle}>{recordTitle}</span>}
                {referenceCode && <span className="reference-code" title={referenceCode}>{referenceCode}</span>}
                {appName && <span className="app-name" title={appName}>{appName}</span>}
            </div>
        )
    }
}
